var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5Elektrik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "air-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 155.6 106.5"
    },
    xmlSpace: "preserve",
    viewBox: "30.7 13.3 94.2 80.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " \t.st0{fill:none;stroke:#000000;stroke-width:3.4;stroke-linecap:round;stroke-miterlimit:10;} \t.st1{fill:none;stroke:#000000;stroke-width:3.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-1",
    d: "M59.4,67.3c-6.5-5.4-10.6-13.6-10.6-22.7C48.8,28.2,62.1,15,78.4,15S108,28.2,108,44.6c0,9-4.1,17.1-10.4,22.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-2",
    d: "M83,24.1L66,41.8c-0.8,0.8-0.2,2.1,0.9,2.1H74l-2.4,20c-0.1,1.2,1.4,1.9,2.2,1l16.4-18.3  c0.7-0.8,0.2-2.1-0.9-2.1h-6.1l2-19.5C85.3,24,83.8,23.3,83,24.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-3",
    d: "M56,72.5h44.9c10.9-13.5,21.7,0,21.7,0h-10.5l-4.9,7l4.9,6.1h11.1c0,0-11.8,13.6-22.5,0h-44l44,0H54.7  c-10.9,13.5-21.7,0-21.7,0h10.5l4.9-7l-4.9-6.1H32.4c0,0,11.8-13.6,22.5,0h45.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Elektrik);
export default __webpack_public_path__ + "static/media/5.elektrik.4eae497324154c8d1e3ded06749cbaa5.svg";
export { ForwardRef as ReactComponent };